export const pixelsUUIDKey = 'ai_pixels_uuid';